import { createStorageAtomFactory } from '@exodus/atoms';
const createBackedUpAtom = ({ storage }) => {
    const atomFactory = createStorageAtomFactory({ storage });
    return atomFactory({ key: 'backedUp', defaultValue: false });
};
export default createBackedUpAtom;
